/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_App_UrlInputs */

const en_admin_settings_fields_app_url = /** @type {(inputs: Admin_Settings_Fields_App_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App URL`)
};

const zh_admin_settings_fields_app_url = /** @type {(inputs: Admin_Settings_Fields_App_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用地址`)
};

/**
* | output |
* | --- |
* | "App URL" |
*
* @param {Admin_Settings_Fields_App_UrlInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_app_url = /** @type {((inputs?: Admin_Settings_Fields_App_UrlInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_App_UrlInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_app_url(inputs)
	return zh_admin_settings_fields_app_url(inputs)
});
export { admin_settings_fields_app_url as "admin.settings.fields.app_url" }